import isEqual from 'lodash.isequal';

import {
    api_test,
    api_req_get_device_list,
    api_req_get_projects_by_user,
    api_req_get_project_desks_by_user_and_project_id,
    api_req_get_devlist_by_desk_id_and_user_id,
    api_req_get_sensorlist_by_desk_id_and_user_id,
    api_req_get_devlist_skeleton_by_desk_id_and_user_id,
    api_req_get_sensors_data_by_dev_id_and_user_id,
    api_req_manager_graph_and_xlsx_data,
    api_req_get_device_skeleton_by_dev_id_and_user_id,
    api_req_get_dev_color_code_by_dev_id,

    api_req_get_devinfo_by_dev_id_and_user_id,
    api_req_get_sensorlist_by_dev_id_and_user_id,
    api_req_device_list_by_user_role,
    api_req_insert_actions, api_req_info_and_sensors_data_of_dev_id,
    api_req_rx_actions_by_dev_id,
    api_req_rx_events_by_dev_id,
    api_req_rx_log_by_dev_id,
    api_req_rx_state_by_dev_id,
    api_req_delete_action_by_id,
    api_req_rx_sensor_data_hourly_by_selectedDevId_sensorId,
    api_req_rx_sensor_data_30m_by_selectedDevId_sensorId,
    api_req_rx_sensor_data_daily_by_selectedDevId_sensorId,
    api_req_data_h_t_by_collection_id_x_days_back,
    api_req_get_data_all_collections,
    api_req_stats_restarting_all_devs_by_5days,
    api_req_data_userid_devid_actions_and_senors_list_by_date,
    api_req_30min_data_by_date_devid_sensorid_fields,
  } from "../Devices/DevServices/api_request"

const UDATE_STATE_ITEM = "UDATE_STATE_ITEM" 
const UPDATE_MOBILE_SKELETON_DEV_ITEM = "UPDATE_MOBILE_SKELETON_DEV_ITEM" 
const UDATE_DEV_LIST = "UDATE_DEV_LIST"
const UPDATE_SELECTED_DEV = "UPDATE_SELECTED_DEV"
const UPDATE_STATS_DATA = "UPDATE_STATS_DATA"
const SET_DEFAULT_SENSOR_COLLECTION_ID = "SET_DEFAULT_SENSOR_COLLECTION_ID"
const UPDATE_SENSOR_COLLECTION_ID = "UPDATE_SENSOR_COLLECTION_ID"

const SET_DEFAULT_MODAL_CHART = "SET_DEFAULT_MODAL_CHART"
const UPDATE_MODAL_CHART = "UPDATE_MODAL_CHART"

const UPDATE_ISLOADING = "UPDATE_ISLOADING"
const INSERT_SENSOR_DATA_INTO_ARRAY = "INSERT_SENSOR_DATA_INTO_ARRAY"
//form_graph_selected_date  form_sensor_field_ignore
const UPDATE_FORM_GRAPH_SELECTED_DATE = "UPDATE_FORM_GRAPH_SELECTED_DATE"
const UPDATE_FORM_SENSOR_FIELD_IGNORE = "UPDATE_FORM_SENSOR_FIELD_IGNORE"
//request_graph_by_sensor
const UPDATE_REQUEST_GRAPH_BY_SENSOR = "UPDATE_REQUEST_GRAPH_BY_SENSOR"
const UPDATE_MOBILE_ACTUAL_DEV_SENSOR_FIELDS = "UPDATE_MOBILE_ACTUAL_DEV_SENSOR_FIELDS"
const TEST = "TEST"

//api_test
const initialState = {
    isLoading: false,
    refreshDataTime: 5000, // default 5 s
    devList: [],
    all_projects:[],
    selected_project_desks: {},
    selected_desk_id: null,
    selected_desk: {},
    selected_desk_skeleton_mobile: [],
    selected_desk_sensorList: [],
    request_graph_by_sensor: {
      dev_id: null,
      sensor_id: null,
      graph_selected_date: null,
      table_name: null,
      field_list: null,
      rx_data_by_date: []
    },
    selectedDev: {
      id: null,
      type: null,
      json_actions: [],
      json_sensors: [],
      name: null,
      description: null,
      selectedActionsFromForm: [],
      rx_action_list: [],
      rx_state_list: [],
      rx_event_list: [],
      rx_log_list: [],
      rx_sensors_data: [],
      requestData: [],
      v2_devinfo: {},
      v2_sensors: {},
    },
    sensors_all_collections: [],
    sensors_collection_id: {
      id: null,
      name_collection: null,
      description: null,
      data_10_days_back: {
        collection_info_by_id: [],
        dev_id_with_name: [],
        union_data: []
      },
      isModal: false,
      modalTitle: "",
      sensor_data_for_modal: []
    },
    modalChart: {
      isModal: false,
      modalTitle: "",
      sensor_data_for_modal: []      
    },
    stats_data: {
      restart_dev_data: [],
    },
    xd_menuData: [
      { name: 'Home', path: '/', children: [] },
      { name: 'Projects', 
        path: '/projects', 
        children: [
        { name: 'Staff', path: '/selected_project/1', children: [] },
        { name: 'ArtXtal', path: '/selected_project/2', children: [] },
        ] },
      { name: 'Log Out', path: '/login', children: [] },
    ],

  };

  export default function (state = initialState, action) {



    if (action.type === UPDATE_ISLOADING) {
      const stateCopy = {
        ...state,
        isLoading: action.value
      };
      return stateCopy;
    }

    if (action.type === UDATE_DEV_LIST) {
      const stateCopy = {
        ...state,
        devList: action.payload
      };
      return stateCopy;
    }

    if (action.type === UDATE_STATE_ITEM) {
      const stateCopy = {
        ...state,
        [action.key]: action.payload
      };
      return stateCopy;
    }  
    
    if (action.type === UPDATE_SELECTED_DEV) {
      const stateCopy = {
        ...state,
        selectedDev: {...state.selectedDev, [action.key]: action.payload}
      };
      return stateCopy;
    }   

    if (action.type === UPDATE_STATS_DATA) {
      const stateCopy = {
        ...state,
        stats_data: {...state.stats_data, [action.key]: action.payload}
      };
      return stateCopy;
    }     
  

    if (action.type === UPDATE_SENSOR_COLLECTION_ID) {
      //console.log("key:", action.key)
      //console.log("payload:", action.payload)
      const stateCopy = {
        ...state,
        sensors_collection_id: {...state.sensors_collection_id, [action.key]: action.payload}
      };
      return stateCopy;
    }   

    if (action.type === SET_DEFAULT_SENSOR_COLLECTION_ID) {
      const stateCopy = {
        ...state,
        sensors_collection_id: initialState.sensors_collection_id
      };
      return stateCopy;
    }

    if (action.type === UPDATE_MODAL_CHART) {
      //console.log("key:", action.key)
      //console.log("payload:", action.payload)
      const stateCopy = {
        ...state,
        modalChart: {...state.modalChart, [action.key]: action.payload}
      };
      return stateCopy;
    }  

    if (action.type === UPDATE_MOBILE_ACTUAL_DEV_SENSOR_FIELDS) {
      /* console.log("key:", action.key)
      console.log("payload:", action.payload.actual_fields) */
      const dev_id = action.payload.dev_id
      const sensor_id = action.payload.sensor_id
      //let's change array element
      const n_array = state.selected_desk_skeleton_mobile.map(v => {
        if (v.dev_id === dev_id) {
          const updatedSensors = v.dev_sensors_data.map(s => {
            if (s.sensor_id === sensor_id) {
              return { ...s, actual_fields: action.payload.actual_fields };
            }
            return s;
          });
      
          return { ...v, dev_sensors_data: updatedSensors };
        }
      
        return v;
      });
        const stateCopy = {
          ...state,
          selected_desk_skeleton_mobile: n_array
        };

        return stateCopy;
    }  

    if (action.type === UPDATE_REQUEST_GRAPH_BY_SENSOR) {
      //console.log("key:", action.key)
      //console.log("payload:", action.payload)
      const stateCopy = {
        ...state,
        request_graph_by_sensor: {...state.request_graph_by_sensor, [action.key]: action.payload}
      };
      return stateCopy;
    }     

    if (action.type === UPDATE_MOBILE_SKELETON_DEV_ITEM) {
/*       console.log("dev_id:", action.dev_id)
      console.log("key:", action.key)
      console.log("payload:", action.payload) */
      const stateCopy = {
        ...state,
        selected_desk_skeleton_mobile: state.selected_desk_skeleton_mobile.map(v => {
          if (v.dev_id === action.dev_id){
            return {...v, [action.key]: action.payload}
          }
          return v
        })
      };
      return stateCopy;
    }      

/*     if (action.type === UPDATE_MOBILE_SKELETON_DEV_ITEM) {
      console.log("dev_id:", action.dev_id)
      console.log("key:", action.key)
      console.log("payload:", action.payload)

      let stateCopy = {...state}
      const filter_dev = state.selected_desk_skeleton_mobile.filter(v => v.dev_id === action.dev_id)
      //if (!filter_dev) return {...state}
      console.log(state)
      console.log(filter_dev[0])
      if (filter_dev[0].dev_sensors_data) console.log('Nooo data')
      //check dev_sensors_data

      //console.log(filter_dev[0].dev_sensors_data)
      if (filter_dev[0].dev_sensors_data === null) {
        console.log('Hello if')
        console.log()
        stateCopy = {
          ...state,
          selected_desk_skeleton_mobile: state.selected_desk_skeleton_mobile.map(v => {
            if (v.dev_id === action.dev_id){
              return {...v, [action.key]: action.payload}
            }
            return v
          })
        };
      }


      return stateCopy;
    }   */   
    if (action.type === TEST) {
      //[action.key]: action.payload
      console.log('Hello test!')
      console.log(state)
      const stateCopy = {
        ...state
      };
      return stateCopy;
    }  

    if (action.type === SET_DEFAULT_MODAL_CHART) {
      const stateCopy = {
        ...state,
        modalChart: initialState.modalChart
      };
      return stateCopy;
    }  

    if (action.type === INSERT_SENSOR_DATA_INTO_ARRAY) {
      //action.payload = []
      const stateCopy = {
        ...state,
        selectedDev: {
          ...state.selectedDev,
          rx_sensors_data: [
            ...state.selectedDev.rx_sensors_data, // Spread existing data
            action.payload // Add new sensor data
          ]
        }
      };
      
      return stateCopy;
    }


    if (action.type === UPDATE_FORM_GRAPH_SELECTED_DATE) {
      //console.log(action.idate, action.dev_id, action.sensor_id)

      const stateCopy = {
        ...state,
        selected_desk_sensorList: state.selected_desk_sensorList.map(v=>{
          if (v.id === action.dev_id) {
            return {...v, sensors: v.sensors.map(s => {
              if (s.sensor_id === action.sensor_id) {
                return {...s, form_graph_selected_date: action.idate }
              }
              return s
            }) }
          }
          return v;
        })
      };
      return stateCopy;
    }   

    if (action.type === UPDATE_FORM_SENSOR_FIELD_IGNORE) {
      //console.log(action.dev_id, action.sensor_id, action.fieldName)

      const stateCopy = {
        ...state,
        selected_desk_sensorList: state.selected_desk_sensorList.map(v=>{
          if (v.id === action.dev_id) {
            return {...v, sensors: v.sensors.map(s => {
              if (s.sensor_id === action.sensor_id) {
                return {...s, card_sensor_data: s.card_sensor_data.map (f => {
                  if (f.db_field === action.fieldName) {
                    //console.log('eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
                    return {...f, form_sensor_field_ignore:!f.form_sensor_field_ignore }
                  }
                  return f
                }) }
              }
              return s
            }) }
          }
          return v;
        })
      };
      return stateCopy;
    }       

/*     if (action.type === SET_EDIT_ID) {
      const stateCopy = {
        ...state,
        rEditId: action.id
      };
      return stateCopy;
      } */

    return state;
  }
  
  export const update_selected_dev = (key, payload) => ({ type: UPDATE_SELECTED_DEV, key, payload});
  export const update_isLoading = (value) => ({ type: UPDATE_ISLOADING, value});
  //dispatch({ type: UPDATE_SENSOR_COLLECTION_ID, key: "data_10_days_back", payload: response.data });
  export const update_sensor_collections = (key, payload)=> ({ type: UPDATE_SENSOR_COLLECTION_ID, key, payload});
  export const update_modal_chart = (key, payload)=> ({ type: UPDATE_MODAL_CHART, key, payload});
  //UPDATE_MOBILE_SKELETON_DEV_ITEM
  export const update_state_item = (key, payload)=> ({ type: UDATE_STATE_ITEM, key, payload});
  export const update_request_graph_by_sensor = (key, payload)=> ({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key, payload});
  export const update_mobile_actual_dev_sensor_fields = (key, payload)=> ({ type: UPDATE_MOBILE_ACTUAL_DEV_SENSOR_FIELDS, key, payload});
  //UPDATE_MOBILE_ACTUAL_DEV_SENSOR_FIELDS
  export const update_mobile_skeleton_dev_item = (dev_id, key, payload)=> ({ type: UPDATE_MOBILE_SKELETON_DEV_ITEM, dev_id, key, payload});
  
  export const test = (key, payload)=> ({ type: TEST, key, payload});

//const update_dev_list = (payload) => ({ type: UDATE_DEV_LIST, payload});
export const t_decode_selected_dev = (dev_id) => (dispatch, getState) => {
  dispatch(update_isLoading(true));
  
  const state = getState(); // Access current state
  if (state.dev.devList.length === 0) {
      dispatch(update_isLoading(false)); // Ensure loading is stopped if the list is empty
      return; // Exit if the devList is empty
  }
  
  //It has to have data particulary dev_id
  const selected_dev = state.dev.devList.find(v => v.id === Number(dev_id));
  
  if (!selected_dev) {
      console.error(`Device with id ${dev_id} not found.`);
      dispatch(update_isLoading(false)); // Stop loading if the device is not found
      return; // Exit if the selected device is not found
  }

  // Update Dev_id
  dispatch({ type: UPDATE_SELECTED_DEV, key: "id", payload: selected_dev.id });
  dispatch({ type: UPDATE_SELECTED_DEV, key: "type", payload: selected_dev.type });
  dispatch({ type: UPDATE_SELECTED_DEV, key: "name", payload: selected_dev.name });
  dispatch({ type: UPDATE_SELECTED_DEV, key: "description", payload: selected_dev.description });

  // Assuming the response is stored in `json_action`
  const jsonAction = selected_dev.json_action;
  const strObj = convertDbResponseToJson(jsonAction);
  dispatch({ type: UPDATE_SELECTED_DEV, key: "json_actions", payload: strObj });

  // Assuming the response is stored in `json_sensors`
  const jsonSensors = selected_dev.json_sensors;
  const strObjSensors = convertDbResponseToJson(jsonSensors);
  dispatch({ type: UPDATE_SELECTED_DEV, key: "json_sensors", payload: strObjSensors });

  
  
  //RRR maybe it will be better to do on the server side.
  dispatch(t_get_sensor_data_hourly_by_selectedDevId_sensorId_Today())

  //t_decode_selected_devID_softly_data(); //has finish function dispatch(update_isLoading(false))
  //dispatch(update_isLoading(false));
  //const dev_id = state.dev.selectedDev.id;
  const token = state.auth.user.accessToken;

  //dispatch(update_isLoading(true));

  //****************** Repeat code t_decode_selected_devID_softly_data(); ***************************** */
  //It is the same code as t_decode_selected_devID_softly_data();
  //but speed to show data has 8s delay....
  // Fetch RX actions by device ID
  return api_req_rx_actions_by_dev_id(token, { dev_id: dev_id })
  .then((response) => {
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: response.data.message });
      // Fetch RX events by device ID
      return api_req_rx_events_by_dev_id(token, { dev_id: dev_id });
  })
  .then((response) => {
    dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_event_list", payload: response.data.message });
      // Fetch RX log by device ID
      return api_req_rx_state_by_dev_id(token, { dev_id: dev_id });
  })    
  .then((response) => {
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_state_list", payload: response.data.message });
      // Fetch RX log by device ID
      return api_req_rx_log_by_dev_id(token, { dev_id: dev_id });
  })
  .then((response) => {
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_log_list", payload: response.data.message });
  })
  .catch((error) => {
      console.error('Error fetching data:', error.message);
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: [] });
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_state_list", payload: [] });
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_event_list", payload: [] });
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_log_list", payload: [] });
  })
  .finally(() => {
      dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
  });

};

//2024-12-22 variant 2 - request selected
export const t_req_selected_dev = (dev_id) => (dispatch, getState) => {
  dispatch(update_isLoading(true));
  //console.log('Test1: ', dev_id)
  const state = getState(); // Access current state
  if (!state.auth.user?.accessToken) return null

  const token = state.auth.user.accessToken;
  const user_id = state.auth.user.id;

  //Get data from devices by dev_id
  //console.log('dev_id: ', dev_id, 'user_id =', user_id, 'token: ', token)
  return api_req_info_and_sensors_data_of_dev_id(token, { dev_id: dev_id, user_id: user_id })
  .then((response) => {
    dispatch({ type: UPDATE_SELECTED_DEV, key: "requestData", payload: response.data });
   })
  .catch((error) => {
    console.error('Error fetching data:', error.message);
    dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: [] });
    dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_state_list", payload: [] });
    dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_event_list", payload: [] });
    dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_log_list", payload: [] });
    dispatch({ type: UPDATE_SELECTED_DEV, key: "requestData", payload: [] });
  })
  .finally(() => {
      dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
  });

};

//it is use for refresh data
export const t_decode_selected_devID_softly_data = (dev_id) => (dispatch, getState) => {
  const state = getState(); // Access current state
  //const dev_id = state.dev.selectedDev.id;
  //if (!state.dev.selectedDev?.requestData?.info?.id) return null
  
  //const dev_id = state.dev.selectedDev.requestData.info.id 
  //if (!state.dev.selectedDev.selectedDev?.id) return null

  //const dev_id = state.dev.selectedDev.id
  const token = state.auth.user.accessToken;

  dispatch(update_isLoading(true));

  // Fetch RX actions by device ID
  return api_req_rx_actions_by_dev_id(token, { dev_id: dev_id })
  .then((response) => {
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: response.data.message });
      // Fetch RX events by device ID
      return api_req_rx_events_by_dev_id(token, { dev_id: dev_id });
  })
  .then((response) => {
    dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_event_list", payload: response.data.message });
      // Fetch RX log by device ID
      return api_req_rx_state_by_dev_id(token, { dev_id: dev_id });
  })    
  .then((response) => {
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_state_list", payload: response.data.message });
      // Fetch RX log by device ID
      return api_req_rx_log_by_dev_id(token, { dev_id: dev_id });
  })
  .then((response) => {
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_log_list", payload: response.data.message });
  })
  .catch((error) => {
      console.error('Error fetching data:', error.message);
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: [] });
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_state_list", payload: [] });
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_event_list", payload: [] });
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_log_list", payload: [] });
  })
  .finally(() => {
      dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
  });
}

export const t_decode_selected_devID_softly_data_mobile = (dev_id) => (dispatch, getState) => {
  const state = getState(); // Access current state
  //const dev_id = state.dev.selectedDev.id;
  //if (!state.dev.selectedDev?.requestData?.info?.id) return null
  //console.log(state.dev.selectedDev.selectedDev?.id)
  //const dev_id = state.dev.selectedDev.requestData.info.id 
  //if (!state.dev.selectedDev.selectedDev?.id) return null

  //const dev_id = state.dev.selectedDev.id
  const token = state.auth.user.accessToken;
  console.log(dev_id)
  dispatch(update_isLoading(true));
  console.log()
  // Fetch RX actions by device ID
  return api_req_rx_actions_by_dev_id(token, { dev_id: dev_id })
  .then((response) => {
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: response.data.message });
      // Fetch RX events by device ID
      return api_req_rx_events_by_dev_id(token, { dev_id: dev_id });
  })
  .then((response) => {
    dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_event_list", payload: response.data.message });
      // Fetch RX log by device ID
      return api_req_rx_state_by_dev_id(token, { dev_id: dev_id });
  })    
  .then((response) => {
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_state_list", payload: response.data.message });
      // Fetch RX log by device ID
      return api_req_rx_log_by_dev_id(token, { dev_id: dev_id });
  })
  .then((response) => {
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_log_list", payload: response.data.message });
  })
  .catch((error) => {
      console.error('Error fetching data:', error.message);
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: [] });
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_state_list", payload: [] });
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_event_list", payload: [] });
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_log_list", payload: [] });
  })
  .finally(() => {
      dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
  });
}

  export const t_activator_actions_fromForm = (formValues) => (dispatch, getState) => {
    //console.log('hello thunk! t_activator_actions_fromForm', formValues);

    dispatch(update_isLoading(true));

    const state = getState(); // Access current state
    //console.log(state);

    // Convert object to array
    const selectedValue = [];
    const entriesArray = Object.entries(formValues);

    // Create an array of promises
    const promises = entriesArray.map(async (v) => {
        if (v[1]) {
            // Compose Object and send data to the server
            const actionData = {
                dev_id: state.dev.selectedDev?.requestData?.info?.id || state.dev.selected_desk_skeleton_mobile[0]?.dev_id,
                code: v[0],
                int_value: v[1],
                float_value: "",
                str_value: ""
            };
            console.log(actionData)
            // Call the function and return the promise
            //console.log(actionData)
            return api_req_insert_actions(state.auth.user.accessToken, actionData)
                .then(() => {
                    // Optionally, you can push the successful action data to selectedValue
                    //selectedValue.push(actionData);
                });
        }
        return Promise.resolve(); // Return a resolved promise for empty values
    });

    // Wait for all promises to resolve
    Promise.all(promises)
        .then(() => {
            // Dispatch the action after all promises have resolved
            dispatch({ type: UPDATE_SELECTED_DEV, key: "selectedActionsFromForm", payload: selectedValue });
            return api_req_rx_actions_by_dev_id(state.auth.user.accessToken, {dev_id: state.dev.selectedDev.id})
                .then((response) => {
                 // rx_action_list
                 dispatch({type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: response.data.message})
                }

                )
        })
        .catch((error) => {
            console.error('Error sending actions to server:', error);
            // Handle error if needed
        })
        .finally(() => {
            // This will run after all promises are settled (either resolved or rejected)
            dispatch(update_isLoading(false));
        });
};

//export const t_decode_selected_dev = (dev_id) => (dispatch, getState) => {
export const t_refresh_action_list_by_dev_id  = () => (dispatch, getState) => {
  //console.log('hello thunk! refresh_action_list_by_dev_id');
  dispatch(update_isLoading(true));

  const state = getState(); // Access current state
  //console.log(state);

  return api_req_rx_actions_by_dev_id(state.auth.user.accessToken, {dev_id: state.dev.selectedDev.id})
  .then(
      (response) => {
        //console.log(response.data)
        dispatch({type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: response.data.message})

        //update_dev_list(response.data.devices)
        dispatch(update_isLoading(true));
        return Promise.resolve();
      },
      (error) => {
        //console.log(error.message)
        dispatch({type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: []})
        dispatch(update_isLoading(true));
        return Promise.reject();
      }

    )
}

export const t_delete_action_by_id = (action_id) => (dispatch, getState) => {
    //console.log('hello thunk! t_delete_action_by_id');
    dispatch(update_isLoading(true));
  
    const state = getState(); // Access current state

   // /api_req_delete_action_by_id
    return api_req_delete_action_by_id(state.auth.user.accessToken, {id: action_id, dev_id: state.dev.selectedDev.id})
    .then((response) => {
      // Fetch RX actions by device ID
      return api_req_rx_actions_by_dev_id(state.auth.user.accessToken, { dev_id: state.dev.selectedDev.id })
    })
    .then((response) => {
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: response.data.message });
    })
    .catch((error) => {
        console.error('Error fetching data:', error.message);
        dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: [] });
    })
    .finally(() => {
        dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
    });

  }

//Insert data into array rx_sensors_data 
//Sensors qty may be more then 1
export const t_get_sensor_data_hourly_by_selectedDevId_sensorId_Today  = () => (dispatch, getState) => {
  //console.log('hello thunk! t_get_sensor_data_by_selectedDevId_sensorId');
  dispatch(update_isLoading(true));
  
  const state = getState(); // Access current state
  
  //console.log(state.dev.selectedDev.json_sensors);
  const date_i = get_today_date();
  
  //map th sensor's array
  const sensArray = state.dev.selectedDev.json_sensors;
  sensArray.map(v =>{
    return api_req_rx_sensor_data_hourly_by_selectedDevId_sensorId(state.auth.user.accessToken, 
      {dev_id: state.dev.selectedDev.id, sensor_id: v.sensor_id, date_i: date_i})
    .then(
        (response) => {
          //console.log(response.data.rows)
          dispatch({type: INSERT_SENSOR_DATA_INTO_ARRAY, payload: {sensor_id: v.sensor_id, data: response.data.rows}})
  
          //update_dev_list(response.data.devices)
          dispatch(update_isLoading(true));
          return Promise.resolve();
        },
        (error) => {
          console.log(error.message)
          dispatch({type: INSERT_SENSOR_DATA_INTO_ARRAY, payload: {sensor_id: v.sensor_id, data: []}})
          dispatch(update_isLoading(true));
          return Promise.reject();
        }
  
      )
  })

} 

//if (action.type === UPDATE_SENSOR_COLLECTION_ID) {
/* 
    sensors_collection_id: {
      id: null,
      name_collection: null,
      description: null,
      data_10_days_back: {
        dev_id_with_name: [],
        union_data: []
      },
    }api_req_data_h_t_by_collection_id_x_days_back //sensor_data_for_modal
*/
  export const t_get_sensors_collection_by_id = (collection_id) => (dispatch, getState) => {
    const state = getState(); // Access current state
    const days_back = 10;
    dispatch(update_isLoading(true));
  
   //Set initial state
   dispatch({ type: SET_DEFAULT_SENSOR_COLLECTION_ID});
   
   //RX data by id 
   return api_req_data_h_t_by_collection_id_x_days_back(state.auth.user.accessToken, { collection_id: collection_id, days_back: days_back })
   .then(
      (response) => {
        //console.log(response.data)
        dispatch({ type: UPDATE_SENSOR_COLLECTION_ID, key: "data_10_days_back", payload: response.data });
        dispatch({ type: UPDATE_SENSOR_COLLECTION_ID, key: "id", payload: response.data.collection_info_by_id[0].id });
        dispatch({ type: UPDATE_SENSOR_COLLECTION_ID, key: "name_collection", payload: response.data.collection_info_by_id[0].name_collection });
        dispatch({ type: UPDATE_SENSOR_COLLECTION_ID, key: "description", payload: response.data.collection_info_by_id[0].description });
        return Promise.resolve();
      })
   .catch((error) => {
        console.log(error.message)
        dispatch({ type: SET_DEFAULT_SENSOR_COLLECTION_ID});
        return Promise.reject();
      }
    )
  .finally(() => {
      dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
   });  

  };


  /* 
        id: null,
      name_collection: null,
      description: null,
       */
//sensor_data_for_modal
  export const t_get_sensor_data_30m_by_selectedDevId_sensorId_for_modal  = (dev_id, date_i, sensor_id = 1) => (dispatch, getState) => {
    //console.log('hello thunk! t_get_sensor_data_by_selectedDevId_sensorId');
    dispatch(update_isLoading(true));
   
    const state = getState(); // Access current state

//data_for_graphby_day_30min_temperature_humidity
    return api_req_rx_sensor_data_30m_by_selectedDevId_sensorId(state.auth.user.accessToken, 
      {dev_id: dev_id, sensor_id: sensor_id, date_i: date_i})
    .then(
        (response) => {
          //console.log(response.data.rows)
          dispatch({type: UPDATE_SENSOR_COLLECTION_ID, key: "sensor_data_for_modal", payload: response.data.rows})
  
          //update_dev_list(response.data.devices)
          dispatch(update_isLoading(true));
          return Promise.resolve();
        })
    .catch((error) => {
          console.log(error.message)
          dispatch({type: UPDATE_SENSOR_COLLECTION_ID, key: "sensor_data_for_modal", payload: []})
          return Promise.reject();
        }
      )
    .finally(() => {
        dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
     }); 
  

  } 


  export const t_get_sensor_data_by_date = ({dev_id, sensor_id, date_i}) => (dispatch, getState) => {
    const state = getState(); // Access current state
    //console.log('New Hello!',dev_id, sensor_id, date_i)
    if (!state.auth.user?.accessToken) return null

    const token = state.auth.user.accessToken;
    const user_id = state.auth.user.id;

    dispatch(update_isLoading(true));
  
   //Set initial state
   dispatch({ type: SET_DEFAULT_MODAL_CHART});
   
   //RX data by id 
   return api_req_data_userid_devid_actions_and_senors_list_by_date(token, { user_id: user_id, dev_id: dev_id, sensor_id: sensor_id, date_i: date_i })
   .then(
      (response) => {
        //console.log(response.data)
        dispatch({ type: UPDATE_MODAL_CHART, key: "isModal", payload: true });
        dispatch({ type: UPDATE_MODAL_CHART, key: "modalTitle", payload:  `Sensor #${sensor_id}; date: ${date_i}`});
        dispatch({ type: UPDATE_MODAL_CHART, key: "sensor_data_for_modal", payload: response.data });
/*         dispatch({ type: UPDATE_SENSOR_COLLECTION_ID, key: "id", payload: response.data.collection_info_by_id[0].id });
        dispatch({ type: UPDATE_SENSOR_COLLECTION_ID, key: "name_collection", payload: response.data.collection_info_by_id[0].name_collection });
        dispatch({ type: UPDATE_SENSOR_COLLECTION_ID, key: "description", payload: response.data.collection_info_by_id[0].description }); */
        return Promise.resolve();
      })
   .catch((error) => {
        console.log(error.message)
        dispatch({ type: SET_DEFAULT_MODAL_CHART});
        return Promise.reject();
      }
    )
  .finally(() => {
      dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
   });  

  };

  export const t_get_all_collections_info = () => async (dispatch, getState) => {
    //console.log('hello thunk! refresh_action_list_by_dev_id');
    dispatch(update_isLoading(true)); // Start loading
  
    const state = getState(); // Access current state
    //console.log(state);
  
    return api_req_get_data_all_collections(state.auth.user.accessToken)
      .then((response) => {
        // Dispatch the action with the response data
        dispatch({ type: UDATE_STATE_ITEM, key: "sensors_all_collections", payload: response.data.rows });
  
        // Optionally update the device list if needed
        // update_dev_list(response.data.devices); // Uncomment if needed
      })
      .catch((error) => {
        console.error('Error fetching actions:', error.message);
        dispatch({ type: UDATE_STATE_ITEM, key: "sensors_all_collections", payload: [] }); // Clear the action list on error
      })
      .finally(() => {
        dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
      });
  };


  //================= TEST ======
//export const t_decode_selected_dev = (dev_id) => (dispatch, getState) => {
  export const t_get_sensor_data_hourly_by_selectedDevId_sensorId_1  = () => (dispatch, getState) => {
    //console.log('hello thunk! t_get_sensor_data_by_selectedDevId_sensorId');
    dispatch(update_isLoading(true));
   
    const state = getState(); // Access current state
    //console.log(state);
    //["dev_id", "sensor_id", "date_i"]
    //const timeBand = ["hourly"];
    const sensor_id = 1
    const date_i = '2024-11-30'

    return api_req_rx_sensor_data_hourly_by_selectedDevId_sensorId(state.auth.user.accessToken, 
      {dev_id: state.dev.selectedDev.id, sensor_id: sensor_id, date_i: date_i})
    .then(
        (response) => {
          //console.log(response.data.rows)
          dispatch({type: UPDATE_SELECTED_DEV, key: "rx_sensors_data", payload: response.data.rows})
  
          //update_dev_list(response.data.devices)
          dispatch(update_isLoading(true));
          return Promise.resolve();
        },
        (error) => {
          console.log(error.message)
          dispatch({type: UPDATE_SELECTED_DEV, key: "rx_sensors_data", payload: []})
          dispatch(update_isLoading(true));
          return Promise.reject();
        }
  
      ) 
  }  

  export const t_get_sensor_data_30m_by_selectedDevId_sensorId  = () => (dispatch, getState) => {
    //console.log('hello thunk! t_get_sensor_data_by_selectedDevId_sensorId');
    dispatch(update_isLoading(true));
   
    const state = getState(); // Access current state
    //console.log(state);
    //["dev_id", "sensor_id", "date_i"]
    //const timeBand = ["hourly"];
    const sensor_id = 1
    const date_i = '2024-11-30'
//data_for_graphby_day_30min_temperature_humidity
    return api_req_rx_sensor_data_30m_by_selectedDevId_sensorId(state.auth.user.accessToken, 
      {dev_id: state.dev.selectedDev.id, sensor_id: sensor_id, date_i: date_i})
    .then(
        (response) => {
          //console.log(response.data.rows)
          dispatch({type: UPDATE_SELECTED_DEV, key: "rx_sensors_data", payload: response.data.rows})
  
          //update_dev_list(response.data.devices)
          dispatch(update_isLoading(true));
          return Promise.resolve();
        },
        (error) => {
          console.log(error.message)
          dispatch({type: UPDATE_SELECTED_DEV, key: "rx_sensors_data", payload: []})
          dispatch(update_isLoading(true));
          return Promise.reject();
        }
  
      ) 
  } 

  export const t_get_sensor_data_daily_by_selectedDevId_sensorId  = () => (dispatch, getState) => {
    //console.log('hello thunk! t_get_sensor_data_by_selectedDevId_sensorId');
    dispatch(update_isLoading(true));
   
    const state = getState(); // Access current state
    //console.log(state);
    //["dev_id", "sensor_id", "date_i"]
    //const timeBand = ["hourly"];
    const sensor_id = 1
    const days = 7
//data_for_graphby_day_30min_temperature_humidity
    return api_req_rx_sensor_data_daily_by_selectedDevId_sensorId(state.auth.user.accessToken, 
      {dev_id: state.dev.selectedDev.id, sensor_id: sensor_id, days: days})
    .then(
        (response) => {
          //console.log(response.data.rows)
          dispatch({type: UPDATE_SELECTED_DEV, key: "rx_sensors_data", payload: response.data.rows})
  
          //update_dev_list(response.data.devices)
          dispatch(update_isLoading(true));
          return Promise.resolve();
        },
        (error) => {
          console.log(error.message)
          dispatch({type: UPDATE_SELECTED_DEV, key: "rx_sensors_data", payload: []})
          dispatch(update_isLoading(true));
          return Promise.reject();
        }
  
      ) 
  } 
  
  export const thunkTest = (token) => (dispatch) => { //api_req_device_list_by_user_role
    return api_req_get_device_list(token)
    .then(
        (response) => {
          //console.log(response.data)
          dispatch({type: UDATE_DEV_LIST, payload: response.data.devices})

          //update_dev_list(response.data.devices)
          return Promise.resolve();
        },
        (error) => {
          console.log(error.message)
          dispatch({type: UDATE_DEV_LIST, payload: []})
          return Promise.reject();
        }
  
      )

  }

  export const t_api_req_device_list_by_user_role = () => (dispatch, getState) => {
    dispatch(update_isLoading(true));
   
    const state = getState(); // Access current state

    return api_req_device_list_by_user_role(state.auth.user.accessToken, {user_id: state.auth.user.id})
    .then(
        (response) => {
          //console.log(response.data)
          dispatch({type: UDATE_DEV_LIST, payload: response.data.devices})

          //update_dev_list(response.data.devices)
          return Promise.resolve();
        },
        (error) => {
          console.log(error.message)
          dispatch({type: UDATE_DEV_LIST, payload: []})
          return Promise.reject();
        }
  
      )

  }
//UPDATE_STATS_DATA
 export const t_get_stats_restarting_all_devs_by_5days  = () => async (dispatch, getState) => {
    dispatch(update_isLoading(true));
   
    const state = getState(); // Access current state

//data_for_graphby_day_30min_temperature_humidity
    return api_req_stats_restarting_all_devs_by_5days(state.auth.user.accessToken)
    .then(
        (response) => {
          //console.log(response.data.rows)
          dispatch({type: UPDATE_STATS_DATA, key: "restart_dev_data", payload: response.data.rows})
  
          //update_dev_list(response.data.devices)
          dispatch(update_isLoading(true));

        })
    .catch((error) => {
      console.error('Error fetching actions:', error.message);
      dispatch({ type: UPDATE_STATS_DATA, key: "restart_dev_data", payload: [] }); // Clear the action list on error
    })
    .finally(() => {
      dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
    });
  } 

  //2025-01-08
  export const t_get_all_projects  = () => async (dispatch, getState) => {
    //console.log('Hello1')
    dispatch(update_isLoading(true));
  
    const state = getState(); // Access current state
    if (!state.auth.user?.accessToken) return null
    
/*     console.log(state.auth.isLoggedIn)
    if (!state.auth.isLoggedIn) return */
    const token = state.auth.user.accessToken;
    const user_id = state.auth.user.id;
    
//data_for_graphby_day_30min_temperature_humidity
    return api_req_get_projects_by_user(token, user_id)
    .then(
        (response) => {
          //console.log(response.data)
          dispatch({type: UDATE_STATE_ITEM, key: "all_projects", payload: response.data?.projects || null})
  
          //update_dev_list(response.data.devices)
          dispatch(update_isLoading(true));

        })
    .catch((error) => {
      console.error('Error fetching actions:', error.message);
      dispatch({ type: UDATE_STATE_ITEM, key: "all_projects", payload: [] }); // Clear the action list on error
    })
    .finally(() => {
      dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
    });
  } 


  //2025-01-08
  export const t_get_project_desks_by_user_and_project_id = (project_id) => async (dispatch, getState) => {
    //console.log('Hello1') api_req_get_project_desks_by_user_and_project_id
    dispatch(update_isLoading(true));
  
    const state = getState(); // Access current state
    if (!state.auth.user?.accessToken) return null

    const token = state.auth.user.accessToken;
    const user_id = state.auth.user.id;

//data_for_graphby_day_30min_temperature_humidity
    return api_req_get_project_desks_by_user_and_project_id(token, user_id, project_id)
    .then(
        (response) => {
          //console.log(response.data)
          dispatch({type: UDATE_STATE_ITEM, key: "selected_project_desks", payload: response.data})
  
          //update_dev_list(response.data.devices)
          dispatch(update_isLoading(true));

        })
    .catch((error) => {
      console.error('Error fetching actions:', error.message);
      dispatch({ type: UDATE_STATE_ITEM, key: "restart_dev_data", payload: {} }); // Clear the action list on error
    })
    .finally(() => {
      dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
    });
  } 

    //2025-01-09
    //export const t_get_devlist_by_desk_id_and_user_id = (desk_id) => async (dispatch, getState) => {
      export const t_get_devlist_by_desk_id_and_user_id = () => async (dispatch, getState) => {
      //console.log(desk_id)
      dispatch(update_isLoading(true));
    
      const state = getState(); // Access current state
      if (!state.auth.user?.accessToken) return null

      const token = state.auth.user.accessToken;
      const user_id = state.auth.user.id;
      const desk_id = state.dev.selected_desk_id
  
  //data_for_graphby_day_30min_temperature_humidity
      return api_req_get_devlist_by_desk_id_and_user_id(token, user_id, desk_id)
      .then(
          (response) => {
            //console.log(response.data)
            dispatch({type: UDATE_STATE_ITEM, key: "selected_desk", payload: response.data})
    
            //update_dev_list(response.data.devices)
            dispatch(update_isLoading(true));
  
          })
      .catch((error) => {
        console.error('Error fetching actions:', error.message);
        dispatch({ type: UDATE_STATE_ITEM, key: "restart_dev_data", payload: {} }); // Clear the action list on error
      })
      .finally(() => {
        dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
      });
    } 


    //2025-01-09
    export const t_get_sensorlist_by_desk_id_and_user_id = () => async (dispatch, getState) => {

      dispatch(update_isLoading(true));
    
      const state = getState(); // Access current state
      if (!state.auth.user?.accessToken) return null
  
      const token = state.auth.user.accessToken;
      const user_id = state.auth.user.id;
      const desk_id = state.dev.selected_desk_id

  //data_for_graphby_day_30min_temperature_humidity
      return api_req_get_sensorlist_by_desk_id_and_user_id(token, user_id, desk_id)
      .then(
          (response) => {
            //console.log(response.data)
            dispatch({type: UDATE_STATE_ITEM, key: "selected_desk_sensorList", payload: response.data.sensor_list})
    
            //update_dev_list(response.data.devices)
            dispatch(update_isLoading(true));
  
          })
      .catch((error) => {
        console.error('Error fetching actions:', error.message);
        dispatch({ type: UDATE_STATE_ITEM, key: "selected_desk_sensorList", payload: [] }); // Clear the action list on error
      })
      .finally(() => {
        dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
      });
    } 

      //2025-01-13
    export const t_get_devinfo_by_desk_id_and_user_id = () => async (dispatch, getState) => {
      //console.log(desk_id)
      dispatch(update_isLoading(true));
    
      const state = getState(); // Access current state
      if (!state.auth.user?.accessToken) return null
  
      const token = state.auth.user.accessToken;
      const user_id = state.auth.user.id;
      const dev_id = state.dev.selectedDev.id
      console.log('user_id, dev_id: ', user_id, dev_id)
  //data_for_graphby_day_30min_temperature_humidity
      return api_req_get_devinfo_by_dev_id_and_user_id(token, user_id, dev_id)
      .then(
          (response) => {
            //console.log(response.data)
            dispatch({type: UPDATE_SELECTED_DEV, key: "v2_devinfo", payload: response.data})
    
            //update_dev_list(response.data.devices)
            dispatch(update_isLoading(true));
  
          })
      .catch((error) => {
        console.error('Error fetching actions:', error.message);
        dispatch({ type: UPDATE_SELECTED_DEV, key: "v2_devinfo", payload: {} }); // Clear the action list on error
      })
      .finally(() => {
        dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
      });
    } 


    //2025-01-13
    export const t_get_sensorlist_by_dev_id_and_user_id = () => async (dispatch, getState) => {

      dispatch(update_isLoading(true));
    
      const state = getState(); // Access current state
      if (!state.auth.user?.accessToken) return null
  
      const token = state.auth.user.accessToken;
      const user_id = state.auth.user.id;
      const dev_id = state.dev.selectedDev.id

  //data_for_graphby_day_30min_temperature_humidity
      return api_req_get_sensorlist_by_dev_id_and_user_id(token, user_id, dev_id)
      .then(
          (response) => {
            //console.log(response.data)
            dispatch({type: UPDATE_SELECTED_DEV, key: "v2_sensors", payload: response.data})
    
            //update_dev_list(response.data.devices)
            dispatch(update_isLoading(true));
  
          })
      .catch((error) => {
        console.error('Error fetching actions:', error.message);
        dispatch({ type: UPDATE_SELECTED_DEV, key: "v2_sensors", payload: {} }); // Clear the action list on error
      })
      .finally(() => {
        dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
      });
    } 

    export const t_graph_update_graph_selectedDate_by_devId_and_sensorId = (idate, dev_id, sensor_id) => (dispatch, getState) => {
      //console.log(idate, dev_id, sensor_id)
      dispatch({ type: UPDATE_FORM_GRAPH_SELECTED_DATE, idate: idate, dev_id: dev_id, sensor_id: sensor_id }); // Clear the action list on error
      //const state = getState(); // Access current state
    }
    
    export const t_graph_update_graph_field_prop_by_devId_and_sensorId = (dev_id, sensor_id, fieldName) => (dispatch, getState) => {
      //console.log(dev_id, sensor_id, fieldName)
      //const state = getState(); // Access current state UPDATE_FORM_SENSOR_FIELD_IGNORE
      dispatch({ type: UPDATE_FORM_SENSOR_FIELD_IGNORE, fieldName: fieldName, dev_id: dev_id, sensor_id: sensor_id });
    }
        
      export const t_update_request_graph_by_devId_and_sensorId = (dev_id, sensor_id) => (dispatch, getState) => {
        //console.log(dev_id, sensor_id)
        const state = getState(); // Access current state UPDATE_FORM_SENSOR_FIELD_IGNORE
        //Get graph_selected_date
        const state_selected_dev = state.dev.selected_desk_sensorList.filter(d => d.id === dev_id)[0]
        const selected_sensor = state_selected_dev.sensors.filter(s => s.sensor_id === sensor_id)[0]
        const card_sensor_data = selected_sensor.card_sensor_data
        .map(d => {
          if (!d.form_sensor_field_ignore) return d.db_field
        })
        .filter(f => f !== undefined)

        //console.log(state_selected_dev)
        //console.log(card_sensor_data)
        dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "dev_id", payload: dev_id});
        dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "sensor_id", payload: sensor_id});
        dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "graph_selected_date", payload: selected_sensor.form_graph_selected_date});
        dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "table_name", payload: selected_sensor.db_info.db_table});
        dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "field_list", payload: card_sensor_data});
      }        

      export const t_update_request_graph_by_devId_and_sensorId2 = (dev_id, sensor_id, state_selected_dev, idate) => (dispatch, getState) => {
        //console.log(dev_id, sensor_id)
        const state = getState(); // Access current state UPDATE_FORM_SENSOR_FIELD_IGNORE
        //Get graph_selected_date
        //const state_selected_dev = state.dev.selected_desk_sensorList.filter(d => d.id === dev_id)[0]
        const selected_sensor = state_selected_dev.sensors.filter(s => s.sensor_id === sensor_id)[0]
        const card_sensor_data = selected_sensor.card_sensor_data
        .map(d => {
          if (!d.form_sensor_field_ignore) return d.db_field
        })
        .filter(f => f !== undefined)

        //console.log(selected_sensor)
        //console.log(card_sensor_data)
        dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "dev_id", payload: dev_id});
        dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "sensor_id", payload: sensor_id});
        dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "graph_selected_date", payload: idate});
        dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "table_name", payload: selected_sensor.db_info.db_table});
        dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "field_list", payload: card_sensor_data});
  
      } 

      export const t_update_request_graph_rx_data = (pData={}) => (dispatch, getState) => {
        //console.log('Hello t_update_request_graph_rx_data')
        //api_req_30min_data_by_date_devid_sensorid_fields
        //const {dev_id, sensor_id, date_i, fields} = req.body
        const state = getState(); // Access current state
        if (!state.auth.user?.accessToken) return null

        const token = state.auth.user.accessToken;
        const user_id = state.auth.user.id;
        
        const pData = {
          dev_id: state.dev.request_graph_by_sensor.dev_id,
          sensor_id: state.dev.request_graph_by_sensor.sensor_id,
          date_i: state.dev.request_graph_by_sensor.graph_selected_date,
          fields: state.dev.request_graph_by_sensor.field_list,
        }
        //console.log(state.dev.request_graph_by_sensor)

        dispatch(update_isLoading(true));

    
    //data_for_graphby_day_30min_temperature_humidity
        return api_req_30min_data_by_date_devid_sensorid_fields(token, pData)
        .then(
            (response) => {
              console.log(response.data)
              dispatch({type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "rx_data_by_date", payload: response.data})
      
              //update_dev_list(response.data.devices)
              dispatch(update_isLoading(true));
              //Show modal dialog
              dispatch({type: UPDATE_MODAL_CHART, key: "isModal", payload: true})
              //dispatch({type: UPDATE_MODAL_CHART, key: "modalTitle", payload: `Dev #${pData.dev_id}; Sens #${pData.sensor_id}; Date: ${pData.date_i} - Chart`})
              dispatch({type: UPDATE_MODAL_CHART, key: "modalTitle", payload: `Date: ${pData.date_i} - Chart`})
            })
        .catch((error) => {
          console.error('Error fetching actions:', error.message);
          dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "rx_data_by_date", payload: [] }); // Clear the action list on error
        })
        .finally(() => {
          dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
        });
      }  
      export const t_update_request_graph_rx_data_mobile = (pData={}) => (dispatch, getState) => {
        //api_req_30min_data_by_date_devid_sensorid_fields
        //const {dev_id, sensor_id, date_i, fields} = req.body
        const state = getState(); // Access current state
        if (!state.auth.user?.accessToken) return null

        const token = state.auth.user.accessToken;
        const user_id = state.auth.user.id;
        console.log('Hello from t_update_request_graph_rx_data_mobile')
        console.log(pData)
        if (Object.keys(pData).length === 0) return null

          dispatch(update_isLoading(true));

    
    //data_for_graphby_day_30min_temperature_humidity
        return api_req_30min_data_by_date_devid_sensorid_fields(token, pData)
        .then(
            (response) => {
              //console.log(response.data)
              dispatch({type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "rx_data_by_date", payload: response.data})
      
              //update_dev_list(response.data.devices)
              dispatch(update_isLoading(true));
              //Show modal dialog
              dispatch({type: UPDATE_MODAL_CHART, key: "isModal", payload: true})
              //dispatch({type: UPDATE_MODAL_CHART, key: "modalTitle", payload: `Dev #${pData.dev_id}; Sens #${pData.sensor_id}; Date: ${pData.date_i} - Chart`})
              //dispatch({type: UPDATE_MODAL_CHART, key: "modalTitle", payload: `Date: ${pData.date_i} - Chart`})
              dispatch({type: UPDATE_MODAL_CHART, key: "modalTitle", payload: `Date: ${pData.date_i}`})
            })
        .catch((error) => {
          console.error('Error fetching actions:', error.message);
          dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "rx_data_by_date", payload: [] }); // Clear the action list on error
        })
        .finally(() => {
          dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
        }); 
      }  

      export const t_update_request_graph_rx_data_mobile_pattern_mode = (pData={}) => (dispatch, getState) => {
        //console.log('== Lenin 2 ==')
        //api_req_30min_data_by_date_devid_sensorid_fields
        //const {dev_id, sensor_id, date_i, fields} = req.body
        const state = getState(); // Access current state
        if (!state.auth.user?.accessToken) return null

        const token = state.auth.user.accessToken;
        const user_id = state.auth.user.id;
        //console.log('Hello from t_update_request_graph_rx_data_mobile')
        //console.log(pData)
        if (Object.keys(pData).length === 0) return null

          dispatch(update_isLoading(true));

    
    //data_for_graphby_day_30min_temperature_humidity
        return api_req_manager_graph_and_xlsx_data(token, pData)
        .then(
            (response) => {
              //console.log(response.data)
              dispatch({type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "rx_data_by_date", payload: response.data})
      
              //update_dev_list(response.data.devices)
              dispatch(update_isLoading(true));
              //Show modal dialog
              dispatch({type: UPDATE_MODAL_CHART, key: "isModal", payload: true})
              //dispatch({type: UPDATE_MODAL_CHART, key: "modalTitle", payload: `Dev #${pData.dev_id}; Sens #${pData.sensor_id}; Date: ${pData.date_i} - Chart`})
              //dispatch({type: UPDATE_MODAL_CHART, key: "modalTitle", payload: `Date: ${pData.date_i} - Chart`})
              dispatch({type: UPDATE_MODAL_CHART, key: "modalTitle", payload: `Date: ${pData.date_start}`})
            })
        .catch((error) => {
          console.error('Error fetching actions:', error.message);
          dispatch({ type: UPDATE_REQUEST_GRAPH_BY_SENSOR, key: "rx_data_by_date", payload: [] }); // Clear the action list on error
        })
        .finally(() => {
          dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
        }); 
      } 

//+++++++ Mobile version ++++++
//2025-04-28
    //2025-01-09
    //https://apiwifi.hb41.uk/api/front_02_mobile/get2_devlist_by_desk_id_and_user_id?user_id=1&desk_id=5
    //export const t_get_devlist_by_desk_id_and_user_id = (desk_id) => async (dispatch, getState) => {
      export const t_get_mobile_devlist_skeleton_by_desk_id_and_user_id = () => async (dispatch, getState) => {
        //console.log(desk_id)
        dispatch(update_isLoading(true));
      
        const state = getState(); // Access current state
        if (!state.auth.user?.accessToken) return null
  
        const token = state.auth.user.accessToken;
        const user_id = state.auth.user.id;
        const desk_id = state.dev.selected_desk_id
    
        try {
          const response = await api_req_get_devlist_skeleton_by_desk_id_and_user_id(token, user_id, desk_id);
          //console.log(response.data.message)
          dispatch({
            type: UDATE_STATE_ITEM,  // corrected from UDATE_STATE_ITEM
            key: "selected_desk_skeleton_mobile",
            payload: response.data.message,
          });
          
          // comlete data from sensors
          await dispatch(t_collect_sensorsdata_by_devs_skeleton_mobile());
          await dispatch(t_get_dev_color_code_by_devs_skeleton_mobile());
          //test mode
          //await dispatch(t_get_and_update_sensor_last_value_by_state_devs_mobile());

        } catch (error) {
          console.error("Error fetching device list skeleton:", error.message);
          dispatch({ // Clear the action list on error
            type: UDATE_STATE_ITEM,
            key: "restart_dev_data",
            payload: {},
          });
        } finally {
          dispatch(update_isLoading(false));
        }
      }

      export const t_api_req_get_device_skeleton_by_dev_id_and_user_id = () => async (dispatch, getState) => {
        //console.log(desk_id)
        dispatch(update_isLoading(true));
      
        const state = getState(); // Access current state
        if (!state.auth.user?.accessToken) return null
  
        const token = state.auth.user.accessToken;
        const user_id = state.auth.user.id;
        const dev_id = state.dev.selectedDev.id
        //console.log(' user_id, dev_id: ', user_id, dev_id)
    
        try {
          const response = await api_req_get_device_skeleton_by_dev_id_and_user_id(token, user_id, dev_id);
          //console.log(response.data.message)
          dispatch({
            type: UDATE_STATE_ITEM,  // corrected from UDATE_STATE_ITEM
            key: "selected_desk_skeleton_mobile",
            payload: response.data.message,
          });
          //console.log('Hello!')
          // comlete data from sensors
          await dispatch(t_collect_sensorsdata_by_devs_skeleton_mobile());

          await dispatch(t_get_dev_color_code_by_devs_skeleton_mobile());
          
          //test mode
          //await dispatch(t_get_and_update_sensor_last_value_by_state_devs_mobile());

        } catch (error) {
          console.error("Error fetching device list skeleton:", error.message);
          dispatch({ // Clear the action list on error
            type: UDATE_STATE_ITEM,
            key: "restart_dev_data",
            payload: {},
          });
        } finally {
          dispatch(update_isLoading(false));
        }
      }

      export const t_collect_sensorsdata_by_devs_skeleton_mobile = () => async (dispatch, getState) => {
      //export const t_api_req_get_sensors_data_by_dev_id_and_user_id = () => async (dispatch, getState) => {
        //console.log(desk_id)
        dispatch(update_isLoading(true));
        //t_collect_sensorsdata_by_devs_skeleton_mobile
        const state = getState(); // Access current state
        if (!state.auth.user?.accessToken) return null
  
        const token = state.auth.user.accessToken;
        const user_id = state.auth.user.id;
        const desk_id = state.dev.selected_desk_id
        //console.log(state.dev.selected_desk_skeleton_mobile)
        
        //walk on devices and put sensors data
        const devs_array = state.dev.selected_desk_skeleton_mobile
        //console.log (devs_array)
        for (const dev of devs_array) {
          try {
            const response = await api_req_get_sensors_data_by_dev_id_and_user_id(token, user_id, dev.dev_id);
            //console.log(response.data.message)
            //dev_sensors_data //UPDATE_MOBILE_SKELETON_DEV_ITEM
            dispatch({
              type: UPDATE_MOBILE_SKELETON_DEV_ITEM,  // corrected from UDATE_STATE_ITEM
              dev_id: dev.dev_id,
              key: "dev_sensors_data",
              payload: response.data.message,
            });
            
            // comlete data from sensors
            //await dispatch(t_collect_sensorsdata_by_devs_skeleton_mobile());
  
          } catch (error) {
            console.error("Error fetching device list skeleton:", error.message);
            dispatch({ // Clear the action list on error
              type: UPDATE_MOBILE_SKELETON_DEV_ITEM,
              dev_id: dev.dev_id,
              key: "dev_sensors_data",
              payload: null,
            });
          } finally {
            //dispatch(update_isLoading(false));
          }
        }

        dispatch(update_isLoading(false));

      }   

      export const t_get_dev_color_code_by_devs_skeleton_mobile = () => async (dispatch, getState) => {
        //export const t_api_req_get_sensors_data_by_dev_id_and_user_id = () => async (dispatch, getState) => {
          //console.log(desk_id)
          dispatch(update_isLoading(true));
          //t_collect_sensorsdata_by_devs_skeleton_mobile
          const state = getState(); // Access current state
          if (!state.auth.user?.accessToken) return null
    
          const token = state.auth.user.accessToken;
          const user_id = state.auth.user.id;
          const desk_id = state.dev.selected_desk_id
          //console.log(state.dev.selected_desk_skeleton_mobile)
          
          //walk on devices and put sensors data
          const devs_array = state.dev.selected_desk_skeleton_mobile
          //console.log (devs_array)
          for (const dev of devs_array) {
            //console.log('Hello!')
/*             dispatch({
              type: UPDATE_MOBILE_SKELETON_DEV_ITEM,  // corrected from UDATE_STATE_ITEM
              dev_id: dev.dev_id,
              key: "dev_color_code",
              payload: 9999, //response.data.rows,
            }); */

            try {
              const response = await api_req_get_dev_color_code_by_dev_id(token, user_id, dev.dev_id);
              //console.log(response.data.message)
              //dev_sensors_data //UPDATE_MOBILE_SKELETON_DEV_ITEM
              dispatch({
                type: UPDATE_MOBILE_SKELETON_DEV_ITEM,  // corrected from UDATE_STATE_ITEM
                dev_id: dev.dev_id,
                key: "dev_color_code",
                //payload: response.data.rows[0]?.max_color_code || null,
                payload: response.data.rows
              });
              
              // comlete data from sensors
              //await dispatch(t_collect_sensorsdata_by_devs_skeleton_mobile());
    
            } catch (error) {
              console.error("Error fetching device list skeleton:", error.message);
              dispatch({ // Clear the action list on error
                type: UPDATE_MOBILE_SKELETON_DEV_ITEM,
                dev_id: dev.dev_id,
                key: "dev_sensors_data",
                payload: null,
              });
            } finally {
              //dispatch(update_isLoading(false));
            }
          }
  
          dispatch(update_isLoading(false));
  
        } 

//api_req_get_sensors_data_by_dev_id_and_user_id

/* request_graph_by_sensor
    request_fraph_by_sensor: { form_graph_selected_date
      dev_id: null,
      sensor_id: null,
      graph_selected_date: null,
      table_name: null,
      field_list: null,
    },
*/      
  //====== HELPER Functions KINGDOM ============== //selected_desk_sensorList
  const convertDbResponseToJson = (dbResponse) => {
    // Step 1: Clean the string
    const cleanedString = dbResponse
      .replace(/[\r\n]+/g, '') // Remove new lines
      .replace(/;\s*$/, '') // Remove trailing semicolon
      .replace(/(\w+):/g, '"$1":') // Wrap keys in double quotes
      .replace(/'/g, '"') // Replace single quotes with double quotes
      .replace(/,\s*([\}\]])/g, '$1') // Remove trailing commas before closing brackets
      .replace(/(\s*:\s*)(null)/g, '$1null') // Ensure null is not quoted
      .replace(/(\s*:\s*)(true|false)/g, '$1$2') // Ensure booleans are not quoted
  
  
    // Step 2: Parse the cleaned string
    try {
      const parsedJson = JSON.parse(cleanedString);
      return parsedJson;
    } catch (error) {
      console.error('Error parsing JSON:', error);
      return []; // or handle the error as needed
    }
  };

function get_today_date () {
  const date = new Date();
  const formattedDate = date.toISOString().slice(0, 10);
  return formattedDate
  //console.log(formattedDate); // Outputs: 2024-11-30
}



// Templates
export const t_simpleTempl = () => async (dispatch, getState) => {
  //console.log('hello thunk! refresh_action_list_by_dev_id');
  dispatch(update_isLoading(true)); // Start loading

  const state = getState(); // Access current state
  //console.log(state);

  return api_req_rx_actions_by_dev_id(state.auth.user.accessToken, { dev_id: state.dev.selectedDev.id })
    .then((response) => {
      // Dispatch the action with the response data
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: response.data.message });

      // Optionally update the device list if needed
      // update_dev_list(response.data.devices); // Uncomment if needed
    })
    .catch((error) => {
      console.error('Error fetching actions:', error.message);
      dispatch({ type: UPDATE_SELECTED_DEV, key: "rx_action_list", payload: [] }); // Clear the action list on error
    })
    .finally(() => {
      dispatch(update_isLoading(false)); // Ensure loading is stopped in both success and error cases
    });
};